<template>
  <div id="tf-mesincrease" class="text-center">
    <div class="overlay">
      <div class="container">
        <div class="section-title center">
          <h2>
            MES{{ $t("home.increase1") }}<strong> {{ $t("home.increase2") }}</strong>
          </h2>
          <div class="line">
            <hr />
          </div>
        </div>
        <div class="flexBox">
          <div class="items">
            <div class="items_content">
              <div class="title">{{ $t("home.gain") }}</div>
              <div class="rate">
                <h3>
                  60%<span>/{{ $t("home.average1") }}</span>
                </h3>
              </div>
              <div class="list">
                <div class="list-item">
                  <p class="percent">65%</p>
                  <div class="bar" style="width: 65%"></div>
                  <p>{{ $t("home.average1in1") }}</p>
                </div>
                <div class="list-item">
                  <p class="percent">90%</p>
                  <div class="bar" style="width: 90%"></div>
                  <p>{{ $t("home.average1in2") }}</p>
                </div>
                <div class="list-item">
                  <p class="percent">22%</p>
                  <div class="bar" style="width: 22%"></div>
                  <p>{{ $t("home.average1in3") }}</p>
                </div>
              </div>
            </div>
            <div class="bottombtn" @click="purchase">{{ $t("home.purchase") }}</div>
          </div>
          <div class="items" style="margin-bottom: 0px">
            <div class="items_content">
              <div class="title">{{ $t("home.coast") }}</div>
              <div class="rate">
                <h3>
                  50%<span>/{{ $t("home.average2") }}</span>
                </h3>
              </div>
              <div class="list">
                <div class="list-item">
                  <p class="percent">35%</p>
                  <div class="bar" style="width: 35%"></div>
                  <p>{{ $t("home.average2in1") }}</p>
                </div>
                <div class="list-item">
                  <p class="percent">80%</p>
                  <div class="bar" style="width: 80%"></div>
                  <p>{{ $t("home.average2in2") }}</p>
                </div>
                <div class="list-item">
                  <p class="percent">32%</p>
                  <div class="bar" style="width: 32%"></div>
                  <p>{{ $t("home.average2in3") }}</p>
                </div>
              </div>
            </div>
            <div class="bottombtn" @click="purchase">
              {{ $t("home.purchase") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const purchase = () => {
  message.info(t("home.purchaseinfo"));
};
</script>

<style scoped>
#tf-mesincrease {
  background: url("@/assets/img/mesincrease.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  color: #ffffff;
}
h2,
h3,
h4,
h5,
h6 {
  margin-top: 11px;
  font-style: normal;
  line-height: 1.2;
  font-weight: 700;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}
p {
  margin: 0;
}
.flexBox {
  display: flex;
  justify-content: space-around;
  font-family: "Rubik", sans-serif;
  align-items: center;
}
@media (max-width: 767px) {
  .flexBox {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-family: "Rubik", sans-serif;
  }
}
.items {
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 70px 0;
  position: relative;
  z-index: 1;
  color: #747474;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  max-width: 420px;
}
@media (max-width: 767px) {
  .items {
    margin-bottom: 50px;
  }
}
.items::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 70px;
  background: #18191d;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.items_content {
  box-sizing: border-box;
  position: relative;
  padding: 15% 0 0;
  max-width: 280px;
}
.title {
  color: #18191d;
  text-shadow: 0 0 0 rgba(0, 0, 0, 0.25);
  font-size: 26px;
  font-weight: bold;
  line-height: 30px;
  margin-bottom: 18px;
}
.rate {
  margin-bottom: 33px;
}
.rate h3 {
  font-family: "Rubik", sans-serif;
  margin: 0px;
  color: #18191d;
  text-shadow: 0 0 0 rgba(0, 0, 0, 0.25);
  font-size: 48px;
  font-weight: bold;
  transition: 0.5s;
}
.items:hover .rate h3 {
  color: #f60;
}
.rate span {
  color: #747474;
  font-size: 20px;
  font-weight: 400;
}
.list {
  display: block;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
}
.list-item {
  margin-bottom: 30px;
}
.bar {
  margin: 5px 0px;
  height: 2px;
  background-color: #000000;
  transition: 0.5s;
}
.percent {
  font-weight: bold;
  font-size: 24px;
}
.bottombtn {
  display: inline-block;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  text-decoration: none;
  padding: 22px 0px;
  text-align: center;
  width: 100%;
  cursor: pointer;
}
.items:hover .bar {
  background-color: #ff6600;
}
.items:hover::after {
  width: 100%;
}
.items::after {
  position: absolute;
  content: "";
  height: 70px;
  background: #f60;
  width: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: -1;
  transition: 0.5s;
}
.scrollImg {
  position: relative;
  overflow: hidden;
  height: 250px;
}
.imgBox {
  position: absolute;
  top: 0;
  left: -1px;
  right: -1px;
  bottom: 0;
  z-index: 0;
}
.imgBox img {
  position: absolute;
  left: 50%;
  bottom: 0;
  min-width: 101%;
  min-height: 101%;
  max-width: none;
  transform: translate3d(-50%, 0, 0);
}
</style>
